import axios from "axios"

export const AxiosBase = axios.create({
   baseURL: process.env.REACT_APP_API_ENDPOINT,
})
